import React from 'react';
import { Pencil, Trash2 } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { Button } from './ui/button';

export const TimeEntryActions = ({ entry, onEdit, onDelete, prefix = 'time' }) => {
  const { t } = useTranslation();
  return (
    <div className="flex items-center gap-1 shrink-0">
      <Button variant="ghost" size="icon" className="h-9 w-9 text-zinc-500 hover:text-[#D93025]"
        title={t('timeCorrection.edit')} aria-label={t('timeCorrection.edit')}
        data-testid={`${prefix}-edit-entry-${entry.id}`} onClick={() => onEdit(entry)}>
        <Pencil className="w-4 h-4" />
      </Button>
      <Button variant="ghost" size="icon" className="h-9 w-9 text-zinc-500 hover:text-red-600"
        title={t('timeCorrection.deleteTitle')} aria-label={t('timeCorrection.deleteTitle')}
        data-testid={`${prefix}-delete-entry-${entry.id}`} onClick={() => onDelete(entry)}>
        <Trash2 className="w-4 h-4" />
      </Button>
    </div>
  );
};